<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Invoice</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">HRM</li>
          <li class="breadcrumb-item active" aria-current="page">Invoice</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2"></div>
  </div>
  <!-- /Breadcrumb -->
  <div class="card">
    <div class="card-header d-flex align-items-center flex-wrap row-gap-3" [formGroup]="filterForm">
      <!-- Business Selector -->
      <div
        *ngIf="currentLoggedInUserRole === 'Business Owner' || currentLoggedInUserRole === 'Admin'"
        class="dropdown me-3"
      >
        <select class="form-select" formControlName="selectedBusiness">
          <option value="" selected disabled>Select Business Entity</option>
          <option *ngFor="let item of businessesList" [value]="item.id">
            {{ item.businessName | capitalize }}
          </option>
        </select>
      </div>

      <!-- Payout Frequency Selector -->
      <div class="dropdown me-3">
        <select class="form-select" formControlName="payoutFrequency">
          <option value="" selected disabled>Select Payout Frequency</option>
          <option [value]="PayoutFrequency.MONTHLY">Monthly</option>
          <option [value]="PayoutFrequency.QUARTERLY">Quarterly</option>
          <option [value]="PayoutFrequency.SEMI_ANNUALLY">Semi-Annually</option>
          <option [value]="PayoutFrequency.ANNUALLY">Annually</option>
          <option [value]="PayoutFrequency.WEEKLY">Weekly</option>
          <option [value]="PayoutFrequency.BI_WEEKLY">Bi-Weekly</option>
          <option [value]="PayoutFrequency.DAILY">Daily</option>
        </select>
      </div>

      <!-- DYNAMIC PERIOD SELECTORS -->
      <ng-container [ngSwitch]="filterForm.get('payoutFrequency')?.value">
        <!-- Monthly -->
        <div *ngSwitchCase="PayoutFrequency.MONTHLY" class="dropdown me-3">
          <input type="month" formControlName="selectedMonth" class="form-select" appTrimInput />
        </div>

        <!-- Annual -->
        <div *ngSwitchCase="PayoutFrequency.ANNUALLY" class="dropdown me-3">
          <select formControlName="selectedYear" class="form-select">
            <option *ngFor="let fy of financialYears" [value]="fy.value">
              {{ fy.label }}
            </option>
          </select>
        </div>

        <!-- Semi-Annual -->
        <div
          *ngSwitchCase="PayoutFrequency.SEMI_ANNUALLY"
          class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
        >
          <select formControlName="selectedYear" class="form-select me-2" style="width: 150px">
            <option *ngFor="let fy of financialYears" [value]="fy.value">
              {{ fy.label }}
            </option>
          </select>
          <select formControlName="selectedPeriod" class="form-select">
            <option value="" disabled selected>Select Half</option>
            <option value="h1">First Half (Apr-Sep)</option>
            <option value="h2">Second Half (Oct-Mar)</option>
          </select>
        </div>

        <!-- Quarterly -->
        <div
          *ngSwitchCase="PayoutFrequency.QUARTERLY"
          class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
        >
          <select formControlName="selectedYear" class="form-select me-2" style="width: 150px">
            <option *ngFor="let fy of financialYears" [value]="fy.value">
              {{ fy.label }}
            </option>
          </select>
          <select formControlName="selectedPeriod" class="form-select">
            <option value="" disabled selected>Select Quarter</option>
            <option value="1">Q1 (Apr-Jun)</option>
            <option value="2">Q2 (Jul-Sep)</option>
            <option value="3">Q3 (Oct-Dec)</option>
            <option value="4">Q4 (Jan-Mar)</option>
          </select>
        </div>

        <!-- Weekly, Bi-Weekly, Daily -->
        <div
          *ngSwitchCase="
            PayoutFrequency.WEEKLY || PayoutFrequency.BI_WEEKLY || PayoutFrequency.DAILY
          "
          class="dropdown me-3"
        >
          <input type="date" formControlName="selectedDate" class="form-select" appTrimInput />
        </div>
        <!-- A cleaner way for multiple cases if the above doesn't work -->
        <div *ngSwitchDefault class="dropdown me-3">
          <ng-container
            *ngIf="
              ['weekly', 'bi_weekly', 'daily'].includes(
                filterForm.get('payoutFrequency')?.value || ''
              )
            "
          >
            <input type="date" formControlName="selectedDate" class="form-select" appTrimInput />
          </ng-container>
        </div>
      </ng-container>

      <!-- Search Box -->
      <div
        *ngIf="currentLoggedInUserRole === 'Business Owner' || currentLoggedInUserRole === 'Admin'"
        class="me-3"
      >
        <input
          type="text"
          class="form-control"
          placeholder="Search employees..."
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
          [ngModelOptions]="{ standalone: true }"
        />
      </div>
    </div>
  </div>
  <ng-container *ngIf="filteredpayrolls$ | async as filteredPayrolls; else noPayrolls">
    <div class="card" *ngIf="filteredPayrolls.length > 0; else noPayrolls">
      <div class="card-header">
        <h5 class="card-title">Invoice Preview</h5>
      </div>
      <div class="card-body">
        <table class="table datatable">
          <thead class="thead-light">
            <tr>
              <th scope="col">Employee</th>
              <th scope="col">Invoice</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let payroll of filteredPayrolls">
              <th scope="col">
                <div class="d-flex align-items-center">
                  <a
                    [routerLink]="[eps.hrm.employeePath, payroll.employee.id]"
                    class="avatar avatar-md"
                  >
                    <!-- <img
                        [src]="employee.picture ? businessImages[employee.picture] : defaultImg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      /> -->
                    <ng-container *ngIf="payroll.employee.picture; else initials">
                      <img
                        [src]="imageBaseUrl + payroll.employee.picture"
                        class="img-fluid rounded-circle"
                        alt="img"
                        style="width: 100%; height: 100%; object-fit: cover"
                      />
                    </ng-container>

                    <ng-template #initials>
                      <span
                        class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                        style="width: 30px; height: 30px"
                        >{{
                          getInitials(payroll.employee.firstName, payroll.employee.lastName)
                        }}</span
                      >
                    </ng-template>
                  </a>
                  <div class="ms-2">
                    <p class="text-dark mb-0">
                      <a [routerLink]="[eps.hrm.employeePath, payroll.employee.id]"
                        >{{ payroll.employee.firstName | capitalize }}
                        {{ payroll.employee.lastName | capitalize }}</a
                      >
                      <span class="fs-12"> ({{ payroll.employee.empId }})</span>
                    </p>
                    <span class="fs-12">{{
                      payroll.employee.designation?.designationName | capitalize
                    }}</span>
                  </div>
                </div>
              </th>
              <th scope="col">
                <button (click)="openModal(InvoiceComponent, payroll)" class="btn bg-transparent">
                  <i class="ti ti-eye"></i>
                </button>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
  <ng-template #noPayrolls>
    <div class="alert alert-warning d-flex align-items-center justify-content-center">
      <i class="ti ti-exclamation-circle"></i>
      <span>&nbsp; No invoices available.</span>
    </div>
  </ng-template>
</div>
